import { State } from './state';
import { mutations as TYPES } from './types';

/**
 *
 */
class Rectangle {
  public height: any;
  public width: any;
}

const mutations = {
  [TYPES.RESET](_state: State) {
    _state = new State();
  },
  /**
   * anonymous function
   * @param state ..
   * @param status ..
   */
  [TYPES.TOGGLE_DRAWER](state: any, status = null) {
    if (status != null) {
      state.opening = status;
    } else {
      state.opening = !state.opening;
    }
  },
  /**
   * anonymous function
   * @param state ..
   * @param root0 ..
   * @param root0.height ..
   * @param root0.width ..
   */
  [TYPES.UPDATE_WINDOW_SIZE](state: any, { height, width }: Rectangle) {
    state.windowHeight = height;
    state.windowWidth = width;
  },
};

export default mutations;
